export const LegalTypes = {
    PRIVACY: 17,
    CONDITIONS: 16,
    BIDDING_CONFIRM_CONDITIONS: 18,
};